import { render, staticRenderFns } from "./badge-cell.vue?vue&type=template&id=440a9798"
import script from "./badge-cell.vue?vue&type=script&lang=ts"
export * from "./badge-cell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('440a9798')) {
      api.createRecord('440a9798', component.options)
    } else {
      api.reload('440a9798', component.options)
    }
    module.hot.accept("./badge-cell.vue?vue&type=template&id=440a9798", function () {
      api.rerender('440a9798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/benchmarking-table/cell-types/badge-cell.vue"
export default component.exports